import { EMAIL_PATTERN, isValidPhoneNumber } from '~/lib/business-waitlist-validation';

// Shared by the agency application form and /api/agency-application so both
// sides accept exactly the same input.

export const AGENCY_APPLICATION_FIELDS = [
  'agencyName',
  'monthlySpend',
  'country',
  'email',
  'phone',
] as const;

export type AgencyApplicationField = (typeof AGENCY_APPLICATION_FIELDS)[number];

export type AgencyApplication = Record<AgencyApplicationField, string>;

export const AGENCY_APPLICATION_MAX_LENGTH: Record<AgencyApplicationField, number> = {
  agencyName: 200,
  monthlySpend: 200,
  country: 200,
  email: 254,
  phone: 200,
};

/** Error message per invalid field of trimmed `values`; empty when the application is valid. */
export function validateAgencyApplication(
  values: AgencyApplication,
): Partial<Record<AgencyApplicationField, string>> {
  const errors: Partial<Record<AgencyApplicationField, string>> = {};
  if (values.agencyName.length < 2) errors.agencyName = 'Enter your agency name.';
  if (!values.monthlySpend) errors.monthlySpend = 'Enter your expected monthly spend.';
  if (values.country.length < 2) errors.country = 'Enter your country.';
  if (!EMAIL_PATTERN.test(values.email)) errors.email = 'Enter a valid email address.';
  if (!isValidPhoneNumber(values.phone)) {
    errors.phone = 'Enter a valid phone number with country code.';
  }
  for (const field of AGENCY_APPLICATION_FIELDS) {
    if (values[field].length > AGENCY_APPLICATION_MAX_LENGTH[field]) {
      errors[field] ??= 'This answer is too long.';
    }
  }
  return errors;
}
